import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken  } from "../Global";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";

const ViewCustomer = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});

  useEffect(() => {
        setPermission(FindModuleById(2)); 
console.log(permission);

      
 
    axios
      .get(`/customers/view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.user);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  if(value.company_logo){
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
        accessKeyId: AWS_ACCESS_KEY_ID,
        secretAccessKey: AWS_SECRET_ACCESS_KEY,
        region: AWS_DEFAULT_REGION,
        signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: value.company_logo};
    var user_iamge = s3.getSignedUrl('getObject', params);
  }


  const viewFile =(link) =>{
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: link};
    return  s3.getSignedUrl('getObject', params);
  }
  const editItem = ()=>{
    window.location.href = "/customers-edit/"+id;
  }
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Customers</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/customers">Customers</Link>
                    </li>
                    <li className="breadcrumb-item active">View Customer</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                {permission && permission.list === 1 && (
                  <div className="card-body">
                    <h4 className="card-title">View Customer Information</h4>
                    <div style={{float:"right"}}>
                      <button   onClick={() => editItem()}   className="btn btn-danger me-1"  > Edit Customer </button>
                      </div>
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <th className="p-3">Company Logo</th>
                          <td className="p-3">
                          <img
                                  className="avatar-img"
                                  src={user_iamge}
                                  alt="Profile Image"
                                  width={200}
                                  height={200}
                                />
                            </td>
                        </tr>
                        <tr>
                          <th className="p-3">Company Name</th>
                          <td className="p-3">{value.company_name}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Company Phone</th>
                          <td className="p-3">{value.company_phone}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Company Website</th>
                          <td className="p-3">{value.company_website}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Company Email</th>
                          <td className="p-3">{value.company_email}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Select Currency</th>
                          <td className="p-3">
                            {value.company_primary_currency
                              ? value.currency.title
                              : ""}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Incoterms</th>
                          <td className="p-3">
                            {value.incoterm ? value.incoterm_name.title : ""}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Payment Term</th>
                          <td className="p-3">
                              {value.payment_terms?.name || ""}

                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">VAT</th>
                          <td className="p-3">{value.vat}</td>
                        </tr>
                      </tbody>
                     
                    </table>

                    <br />
                    <h5 className="card-title">Addresses</h5>

                    <table className="table table-bordered">
                        <thead>
                          <tr>
                              <th className="p-3">Address Type</th>
                              <th className="p-3">Name</th>
                              <th className="p-3">Email</th>
                              <th className="p-3">Phone Number</th>
                              <th className="p-3">street</th>
                              <th className="p-3">City</th>
                              <th className="p-3">Zip Code</th>
                              <th className="p-3">Country</th>
                        </tr>
                        </thead>
                      <tbody>
                        {value.addresses &&
                          value.addresses.map((item, index) => (
                            <tr key={item.id || index}>
                              <td className="p-3">{item.add_type}</td>
                              <td className="p-3">{item.name}</td>
                              <td className="p-3">{item.email}</td>
                              <td className="p-3">{item.phone_number}</td>
                              <td className="p-3">{item.street}</td>
                              <td className="p-3">{item.city}</td>
                              <td className="p-3">{item.zip_code}</td>
                              <td className="p-3">{item.country_name}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>


                    <br />
                    <h5 className="card-title">Brokers</h5>

                    <table className="table table-bordered">
                        <thead>
                          <tr>
                              <th className="p-3">Name</th>
                              <th className="p-3">Phone Number</th>
                              <th className="p-3">Email</th>
                              <th className="p-3">CO Code</th>
                              <th className="p-3">Phyto Type</th>
                              <th className="p-3">Address</th>
                        </tr>
                        </thead>
                      <tbody>
                        {value.brokers &&
                          value.brokers.map((broker, index) => (
                            <tr  key={broker.id || index}>
                              <td className="p-3">{broker.broker_name}</td>
                              <td className="p-3">{broker.broker_phone_number}</td>
                              <td className="p-3">{broker.broker_email}</td>
                              <td className="p-3">{broker.broker_co_code}</td>
                              <td className="p-3">{(broker.broker_phyto_type_title != null)?broker.broker_phyto_type_title:""}</td>
                              <td className="p-3">{broker.broker_address}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    <br />
                    <h5 className="card-title">Contacts</h5>

                    <table className="table table-bordered">
                        <thead>
                          <tr>
                              <th className="p-3">First Name</th>
                              <th className="p-3">Last Name</th>
                              <th className="p-3">Email</th>
                              <th className="p-3">Phone Number</th>
                              <th className="p-3">Function</th>
                        </tr>
                        </thead>
                      <tbody>
                        {value.contacts &&
                          value.contacts.map((contact, index) => (
                            <tr  key={contact.id || index}>
                              <td className="p-3">{contact.contact_first_name}</td>
                              <td className="p-3">{contact.contact_last_name}</td>
                              <td className="p-3">{contact.contact_email}</td>
                              <td className="p-3">{contact.contact_phone_number}</td>
                              <td className="p-3">{contact.contact_function}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    <br />
                    <h5 className="card-title">Contract Documents</h5>

                    <table className="table table-bordered">
                        <thead>
                          <tr>
                              <th className="p-3">Document Name</th>
                              <th className="p-3">Document Type</th>
                              <th className="p-3">Document Attached</th>

                        </tr>
                        </thead>
                      <tbody>
                        {value.customer_contract_documents &&
                          value.customer_contract_documents.map((doc, index) => (
                            <tr  key={doc.id || index}>
                              <td className="p-3">{doc.file_name}</td>
                              <td className="p-3">{doc.file_type_name}</td>
                              <td className="p-3">
                              {doc.link && (
                                  <a
                                    className="btn btn-primary"
                                    href={viewFile(doc.link)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    download
                                  >
                                    Download
                                  </a>
                                )}

                              
                            </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>

                    <br />
                    <h5 className="card-title">Customer Farms</h5>

                    <table className="table table-bordered">
                        <thead>
                          <tr>
                              <th className="p-3">Farm Name</th>
                              <th className="p-3">Location</th>
                              <th className="p-3">GGN Number</th>
                              <th className="p-3">Farm Size</th>
                              <th className="p-3">Estimated Crops</th>
                        </tr>
                        </thead>
                      <tbody>
                        {value.customer_farms &&
                          value.customer_farms.map((farm, index) => (
                            <tr  key={farm.id || index}>
                              <td className="p-3">{farm.name}</td>
                              <td className="p-3">{farm.location}</td>
                              <td className="p-3">{farm.ggn_number}</td>
                              <td className="p-3">{farm.farm_size}</td>
                              <td className="p-3">{farm.estimated_crops}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    <br />
                    <h5 className="card-title">Processing Lines</h5>

                    <table className="table table-bordered">
                        <thead>
                          <tr>
                              <th className="p-3">Location</th>
                              <th className="p-3">GPS Location</th>
                              <th className="p-3">Description</th>
                        </tr>
                        </thead>
                      <tbody>
                      {Array.isArray(value.customer_locations) &&
                      value.customer_locations
                        .filter(location => location) // Remove null values
                        .map((location, index) => (
                          <tr key={location.id || index}>
                            <td className="p-3">{location.title || "N/A"}</td>
                            <td className="p-3">{location.gps_location || "N/A"}</td>
                            <td className="p-3">{location.description || "N/A"}</td>
                          </tr>
                        ))
                    }

                      </tbody>
                    </table>
                    <br />
                    <h5 className="card-title">Users</h5>

                    <table className="table table-bordered">
                        <thead>
                          <tr>
                              <th className="p-3">First Name</th>
                              <th className="p-3">Last Name</th>
                              <th className="p-3">Email</th>
                              <th className="p-3">Function</th>
                              <th className="p-3">User Type</th>
                        </tr>
                        </thead>
                      <tbody>
                        {value.users &&
                          value.users.map((user, index) => (
                            <tr  key={user.id || index}>
                              <td className="p-3">{user.user_first_name}</td>
                              <td className="p-3">{user.user_last_name}</td>
                              <td className="p-3">{user.user_email}</td>
                              <td className="p-3">{user.user_function}</td>
                              <td className="p-3">  {user.user_type === 1 ? 'Administrator' : user.user_type === 2 ? 'Standard' : 'Unknown'}  </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ViewCustomer;
